/**
 * DEV-2684 — rol değişince kişiye özel yetki sıfırlanır. Sunucu, kişinin YÖNETİCİ OLMAYAN rol kümesi
 * değişince sıfırlar (KullaniciModulYetkiServisi::rolDegisinceSifirla); yönetici rolü korunur, kümeye
 * girmez. Rol değiştiren her ekran (Kişiler listesi, personel formu) onayı bu kuralla ve bu metinle sorar.
 */

/** `roles` bazı uçlarda dizi, bazılarında tek nesne döner. */
function rolListesi(roller: any): any[] {
    if (Array.isArray(roller)) {
        return roller;
    }
    return roller ? [roller] : [];
}

/** Yönetici olmayan rol id'leri; sıralı ve benzersiz (sunucunun karşılaştırdığı küme). */
export function yoneticiOlmayanRolIdleri(roller: any): number[] {
    const idler = rolListesi(roller)
        .filter((rol: any) => rol && rol.id != null && Number(rol.is_admin) !== 1)
        .map((rol: any) => Number(rol.id));
    return Array.from(new Set(idler)).sort((a, b) => a - b);
}

/** Bu rol değişiminde sunucu kişiye özel yetkiyi sıfırlar mı (yönetici olmayan küme değişiyor mu)? */
export function rolDegisimiSifirlar(eskiRoller: any, yeniRoller: any): boolean {
    const eski = yoneticiOlmayanRolIdleri(eskiRoller);
    const yeni = yoneticiOlmayanRolIdleri(yeniRoller);
    return eski.length !== yeni.length || eski.some((id, i) => id !== yeni[i]);
}

/** Onay gerekir mi: kişinin kişiye özel yetkisi var ve sunucu bu değişimde sıfırlayacak. */
export function rolDegisimiOnayGerekir(ozelYetkiSayisi: any, eskiRoller: any, yeniRoller: any): boolean {
    return Number(ozelYetkiSayisi) > 0 && rolDegisimiSifirlar(eskiRoller, yeniRoller);
}

export function rolDegisimiOnayMetni(ozelYetkiSayisi: any): string {
    return `Bu kişinin ${Number(ozelYetkiSayisi) || 0} modülde kişiye özel yetkisi var. `
        + "Rol değişince kişiye özel yetkiler sıfırlanacak. Devam edilsin mi?";
}
